<aca-page-layout [hasError]="!isValidPath">
  <div class="aca-page-layout-header">
    <!-- `selectedRowItemsCount` affiche « N selectionne(s) » a la place du chemin des qu'une
         selection existe. Il est alimente par `onSelectedItemsCountChanged` de `PageComponent`,
         branche plus bas sur la liste. -->
    <adf-breadcrumb [root]="title" [folderNode]="node" [maxItems]="isSmallScreen ? 1 : 0"
                    [selectedRowItemsCount]="selectedRowItemsCount"
                    (navigate)="onBreadcrumbNavigate($event)" />
    <aca-toolbar [items]="actions"></aca-toolbar>
  </div>



  <div class="aca-page-layout-error">
    <aca-generic-error></aca-generic-error>
  </div>

  <div class="aca-page-layout-content">
    <div class="aca-main-content">
      <adf-upload-drag-area [rootFolderId]="node?.id" [disabled]="!canUpload"
                            (updateFileVersion)="onUploadNewVersion($event)">
        <div #filesWorkspace class="alg-files-workspace" [class.alg-files-workspace--preview]="previewOpened">
          <!--
            L'ARBORESCENCE NE SUIT PLUS QUE LE BOUTON D'AFFICHAGE, plus l'etat de la
            previsualisation.

            Elle etait d'abord DETRUITE par un `*ngIf="!previewOpened"` — un aller-retour par
            niveau de profondeur a chaque ouverture, et un re-rendu visible de tout le volet
            gauche. Elle a ensuite ete simplement masquee, ce qui evitait la reconstruction mais
            la faisait toujours disparaitre : ouvrir un fichier revenait a perdre le contexte de
            navigation, et en changer le faisait clignoter.

            Elle reste donc en place pendant la previsualisation ; c'est le `as-split` qui cede la
            largeur. `isSidebarVisible` garde le dernier mot, l'utilisateur peut la replier.
          -->
          <div class="alg-folder-pane" [ngClass]="isSidebarVisible ? 'tree-node-display' : 'tree-node-hide'"
               *ngIf="node?.id" (click)="containerClicked($event)" tabindex="0">
            <!--
              Champ de recherche dans le dossier courant. C'etait un `<input>` nu, en largeur 97 %,
              bordure #ccc et ombre portee appuyee. Il devient un vrai champ de recherche : loupe en
              tete, bouton d'effacement quand il y a du texte, couleurs du theme, anneau de focus.
            -->
            <div class="alg-folder-search-wrapper">
              <div class="alg-folder-search">
                <mat-icon class="alg-folder-search__icon">search</mat-icon>
                <input
                  id="searchTerm"
                  class="alg-folder-search__input"
                  type="text"
                  autocomplete="off"
                  placeholder="Rechercher dans le dossier courant"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="searchInCurrentNode(node)"
                  (click)="isFocused = true"
                />
                <button
                  *ngIf="searchTerm"
                  type="button"
                  class="alg-folder-search__clear"
                  aria-label="Effacer la recherche"
                  (click)="clearFolderSearch()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <!--
                Resultats de la recherche. C'etaient des `<div>` cliquables, une icone unique
                `insert_drive_file` pour tous les fichiers, et un survol bleu vif code en dur. Ce
                sont maintenant de vrais boutons, avec l'icone du type MIME — la meme que la liste
                et l'arborescence — et le dossier qui contient le resultat, sans quoi deux fichiers
                homonymes etaient indistinguables.
              -->
              <div class="alg-folder-search__results" *ngIf="resultSearch?.length > 0 && isFocused">
                <button
                  *ngFor="let res of resultSearch"
                  type="button"
                  class="alg-folder-search__result"
                  [title]="res.entry.name"
                  (click)="nodeClick(res, true)"
                >
                  <mat-icon *ngIf="res.entry.isFolder" class="alg-folder-search__result-icon alg-folder-search__result-icon--folder">
                    folder
                  </mat-icon>
                  <img
                    *ngIf="!res.entry.isFolder"
                    class="alg-folder-search__result-icon"
                    [src]="searchResultIcon(res.entry)"
                    [alt]="res.entry.content?.mimeTypeName || ''"
                  />
                  <span class="alg-folder-search__result-text">
                    <span class="alg-folder-search__result-name">{{ res.entry.name }}</span>
                    <span class="alg-folder-search__result-path">{{ searchResultLocation(res.entry) }}</span>
                  </span>
                </button>
              </div>
            </div>
            <!-- Un fichier choisi dans l'arborescence s'ouvre dans le volet, comme un clic dans la liste. -->
            <app-tree-nodes
              class="alg-folder-tree"
              [node]="node"
              [nodePath]="nodePath"
              (fileSelected)="onTreeFileSelected($event)"
            ></app-tree-nodes>
          </div>

          <button type="button" class="button-toggle" [ngClass]="isSidebarVisible ? 'button-toggle-open' : ''"
                  (click)="toggleSidebar()" [attr.aria-expanded]="isSidebarVisible"
                  [attr.aria-label]="isSidebarVisible ? 'Fermer l\'arborescence' : 'Ouvrir l\'arborescence'"
                  [title]="isSidebarVisible ? 'Fermer l\'arborescence' : 'Ouvrir l\'arborescence'">
            <mat-icon>{{ isSidebarVisible ? 'chevron_left' : 'chevron_right' }}</mat-icon>
          </button>

          <as-split (dragEnd)="onDragEnd($event)" direction="horizontal" [disabled]="!previewOpened">
            <as-split-area [size]="previewOpened ? paneSizes[0]: 100" [minSize]="isSmallScreen ? 0 : 15">
              <!--
                TROIS REGLAGES QUE LA VERSION COMMUNAUTAIRE POSE ET QUI MANQUAIENT ICI.

                - `displayCheckboxesOnHover` revele la coche de selection au survol de la ligne ;
                - `displayDragAndDropHint` affiche l'invite au glisser-deposer, et seulement quand
                  le depot est permis.

                `isDataProvidedExternally` N'EST PAS REPRISE, bien qu'ACA la pose. Elle y vaut
                `!!queryParams`, et cela ne tient QUE parce que leur `queryParams` vaut
                `extractFiltersFromEncodedQuery(queryMap?.get('q'))`, donc `null` en l'absence de
                filtre. Le notre vaut `queryMap.params`, c'est-a-dire TOUJOURS un objet — et
                `!!{}` est vrai. La liaison etait donc active en permanence : la liste attendait
                des donnees de l'exterieur qui ne venaient jamais, et l'ecran restait sur son
                indicateur de chargement.

                `preselectNodes` n'est PAS reprise, bien qu'ACA la pose. Elle y vaut
                `selectedNodesState?.nodes`, et `selectedNodesState` est declare dans
                `PageComponent` sans jamais etre affecte — nulle part dans le depot. La liaison
                vaut donc `undefined` chez ACA comme elle vaudrait ici, mais elle ecraserait a
                chaque cycle de detection ce que `selectClickedRow` et la restauration apres clic
                droit ecrivent dans `preselectNodes`.

                Le tri, lui, etait un vrai defaut : voir `[sorting]`.
              -->
              <adf-document-list
                #documentList
                acaDocumentList
                acaContextActions
                [selectionMode]="'multiple'"
                [multiselect]="true"
                [currentFolderId]="node?.id"
                [loading]="true"
                [showHeader]="showHeader"
                [node]="nodeResult"
                [allowDropFiles]="true"
                [navigate]="false"
                [sorting]="['name', 'asc']"
                [imageResolver]="imageResolver"
                [headerFilters]="true"
                [filterValue]="queryParams"
                [isResizingEnabled]="true"
                [blurOnResize]="false"
                [displayCheckboxesOnHover]="true"
                [displayDragAndDropHint]="canUpload"
                (name-click)="nodeClick($event)"
                (nodeDblClick)="nodeClick($event)"
                (folderChange)="onSortingChanged($event)"
                (filterSelection)="onFilterSelected($event)"
                (selectedItemsCountChanged)="onSelectedItemsCountChanged($event)"
                (error)="onError()"
              >
                <data-columns>
                  <ng-container *ngFor="let column of columns; trackBy: trackByColumnId">
                    <ng-container *ngIf="column.template && !(column.desktopOnly && isSmallScreen)">
                      <data-column
                        [id]="column.id"
                        [key]="column.key"
                        [title]="column.title"
                        [type]="column.type"
                        [format]="column.format"
                        [class]="column.class"
                        [sortable]="column.sortable"
                        [sortingKey]="column.sortingKey || column.key"
                        [isHidden]="column.isHidden"
                        [draggable]="column.draggable"
                        [resizable]="column.resizable"
                      >
                        <ng-template let-context>
                          <adf-dynamic-column [id]="column.template" [context]="context"></adf-dynamic-column>
                        </ng-template>
                      </data-column>
                    </ng-container>

                    <ng-container *ngIf="!column.template && !(column.desktopOnly && isSmallScreen)">
                      <data-column
                        [id]="column.id"
                        [key]="column.key"
                        [title]="column.title"
                        [type]="column.type"
                        [format]="column.format"
                        [class]="column.class"
                        [sortable]="column.sortable"
                        [sortingKey]="column.sortingKey || column.key"
                        [isHidden]="column.isHidden"
                        [draggable]="column.draggable"
                        [resizable]="column.resizable">
                      </data-column>
                    </ng-container>
                  </ng-container>
                  <data-column
                    id="alg.commentaires"
                    title="Commentaires"
                    key="properties.fm:commentCount"
                    class="alg-comments-column adf-ellipsis-cell"
                    [sortable]="false"
                    [draggable]="true"
                    [resizable]="true"
                    [isHidden]="false"
                  >
                    <ng-template let-entry>
                      <div style="width: 100%; display: flex; justify-content: center"
                           *ngIf="getCommentCountForNode(entry.row) > 0">
                        <div class="comment-count">
                          <button type="button" class="comment-count__button"
                                  [attr.aria-label]="'Ouvrir les commentaires (' + getCommentCountForNode(entry.row) + ')'"
                                  (click)="openSidebarDetail($event, entry.row)">
                            <mat-icon>comment</mat-icon>
                          </button>
                          <span class="comment-count__text">
                            {{ getCommentCountForNode(entry.row) }}
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </data-column>
                </data-columns>
                <adf-custom-empty-content-template *ngIf="isFilterHeaderActive">
                  <ng-container>
                    <div class="empty-search__block" aria-live="polite">
                      <p class="empty-search__text">
                        {{ 'APP.BROWSE.SEARCH.NO_FILTER_RESULTS' | translate }}
                      </p>
                    </div>
                  </ng-container>
                </adf-custom-empty-content-template>
              </adf-document-list>
            </as-split-area>
            <as-split-area [visible]="previewOpened" [size]="previewOpened ? paneSizes[1] : 0" style="display: flex" [minSize]="isSmallScreen ? 0 : 15">
              <div *ngIf="previewOpened" class="alg-preview-pane">
                <adf-alfresco-viewer *ngIf="blobFile"
                                     [showToolbar]="true"
                                     closeButtonPosition="left"
                                     [overlayMode]="false"
                                     [nodeId]="nodePreviewed?.id"
                                     [allowPrint]="true"
                                     [showLeftSidebar]="false"
                                     [showRightSidebar]="false"
                                     [hideInfoButton]="isSmallScreen"
                                     [allowDownload]="true"
                                     [allowFullScreen]="true"
                                     class="alg-preview-viewer"
                                     (showViewerChange)=closePreview()>
                  <adf-viewer-toolbar-actions>
                    <button mat-icon-button matTooltip="Tourner le document à 90° vers la gauche"
                            (click)="rotate('left')">
                      <mat-icon>rotate_left</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Tourner le document à 90° vers la droite"
                            (click)="rotate('right')">
                      <mat-icon>rotate_right</mat-icon>
                    </button>
                  </adf-viewer-toolbar-actions>
                </adf-alfresco-viewer>
                <!--
                  Le lecteur media n'apporte pas de barre d'outils : sans cet entete, la
                  previsualisation d'une video ne pouvait plus etre refermee.
                -->
                <div *ngIf="urlMedia" class="alg-preview-media">
                  <div class="alg-preview-header">
                    <span class="alg-preview-header__name" [title]="fileName">{{ fileName }}</span>
                    <button mat-icon-button matTooltip="Fermer la previsualisation" (click)="closePreview()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                  <adf-media-player class="alg-preview-media__player" [urlFile]="urlMedia" [fileName]="fileName"
                                    [mimeType]="mimeType"></adf-media-player>
                </div>

                <div *ngIf="!blobFile && !urlMedia" class="alg-preview-empty">
                  <div id="closePreview" class="alg-preview-empty__header">
                    <span class="alg-preview-header__name" [title]="fileName">{{ fileName }}</span>
                    <button mat-icon-button matTooltip="Fermer la previsualisation" (click)="closePreview()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                  <!--
                    Le volet affichait un indicateur de chargement, et rien d'autre. Sur un type que
                    le serveur ne sait pas convertir en PDF, il tournait sans fin. Il dit maintenant
                    ce qui se passe.
                  -->
                  <div *ngIf="!previewUnavailable" class="alg-preview-loading" role="status" aria-live="polite">
                    <mat-progress-spinner [diameter]="40" [color]="'primary'" [mode]="'indeterminate'"></mat-progress-spinner>
                    <span>Préparation de l'aperçu…</span>
                  </div>
                  <div *ngIf="previewUnavailable" class="alg-preview-unavailable">
                    <mat-icon>visibility_off</mat-icon>
                    <p>Aucun aperçu disponible pour ce type de fichier.</p>
                    <p class="alg-preview-unavailable__hint">Vous pouvez le télécharger pour l'ouvrir.</p>
                  </div>
                </div>

              </div>
            </as-split-area>
          </as-split>
        </div>

        <adf-pagination acaPagination [target]="documentList"></adf-pagination>
      </adf-upload-drag-area>
    </div>

    <div class="aca-sidebar" *ngIf="infoDrawerOpened$ | async">
      <aca-info-drawer [node]="selection.last"></aca-info-drawer>
    </div>
  </div>
</aca-page-layout>

<style>
  .adf-datatable-body {
    overflow: auto !important;
  }

  adf-datatable-row {
    min-height: 40px!important;
  }

  .adf-pdf-viewer__toolbar {
    bottom: 5px !important;
  }

  /*
    Entete du volet de previsualisation : le titre chevauchait les boutons.

    ADF positionne le titre en ABSOLU, centre, et en `white-space: nowrap` :
      .adf-viewer__file-title { position: absolute; left: 50%; transform: translate(-50%); }
    Il ne reserve donc aucune place dans la barre d'outils et ne peut pas se retrecir. Dans la
    visionneuse pleine page d'ACA la barre est large, ca passe ; dans notre volet scinde elle fait
    la moitie de la fenetre, et le titre vient se poser sur telecharger / imprimer.

    On le remet dans le flux, on le laisse se retrecir (`min-width: 0`, indispensable pour qu'un
    element flex puisse passer sous la largeur de son contenu) et on le tronque.
  */
  as-split-area .adf-viewer__file-title {
    position: static !important;
    left: auto !important;
    transform: none !important;
    min-width: 0;
    overflow: hidden;
  }

  as-split-area .adf-viewer__display-name,
  as-split-area .adf-viewer__title-display-name-container {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (min-height: 600px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 60vh !important;
    }
  }

  @media screen and (min-height: 700px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 63vh !important;
    }
  }

  @media screen and (min-height: 800px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 65vh !important;
    }
  }

  @media screen and (min-height: 900px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 69vh !important;
    }
  }

  @media screen and (min-height: 1000px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 72vh !important;
    }
  }

  @media screen and (min-height: 1100px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 74.5vh !important;
    }
  }

  @media screen and (min-height: 1200px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 76.5vh !important;
    }
  }

  @media screen and (min-height: 1300px) {
    :not(aca-viewer) .adf-pdf-viewer__content {
      height: 78vh !important;
    }
  }

  aca-viewer .adf-pdf-viewer__content {
    height: 89vh !important;
  }

  .alg-preview-unavailable {
    height: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 24px;
    text-align: center;
    color: var(--adf-theme-foreground-text-color-064, rgba(0, 0, 0, 0.64));
    white-space: normal;
  }

  .alg-preview-unavailable .mat-icon {
    width: 40px;
    height: 40px;
    font-size: 40px;
    line-height: 40px;
    opacity: 0.5;
  }

  .alg-preview-unavailable p {
    margin: 0;
  }

  .alg-preview-unavailable__hint {
    font-size: 12px;
    opacity: 0.8;
  }

  .alg-preview-header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 4px 4px 12px;
    border-bottom: 1px solid var(--theme-border-color, rgba(0, 0, 0, 0.07));
  }

  .alg-preview-header > button {
    order: -1;
  }

  .alg-preview-header__name {
    position: absolute;
    left: 50%;
    width: calc(100% - 96px);
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transform: translateX(-50%);
    text-align: center;
    pointer-events: none;
    font-size: var(--mat-sys-title-small-size, 14px);
  }



  /*
    Panneau de resultats. Il etait en `position: fixed` avec des marges en dur (10 px, 50 px) pour
    se glisser sous le champ : il restait donc a la meme place a l'ecran quel que soit le
    defilement du volet. Il est desormais ancre sous le champ.
  */
  .alg-folder-search__results {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 3;
    max-height: 40vh;
    overflow: auto;
    box-sizing: border-box;
    padding: 4px;
    background-color: var(--theme-card-background-color, #fff);
    border: 1px solid var(--theme-border-color, rgba(0, 0, 0, 0.12));
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  }

  .alg-folder-search__result {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 0;
    border-radius: 6px;
    background: none;
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;
  }

  /*
    Le survol etait un bleu vif code en dur (#3a7fca) avec texte blanc — une couleur qui n'existe
    nulle part ailleurs dans l'application.
  */
  .alg-folder-search__result:hover,
  .alg-folder-search__result:focus-visible {
    background-color: var(--theme-grey-background-hover, rgba(0, 0, 0, 0.06));
    outline: none;
  }

  .alg-folder-search__result-icon {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    object-fit: contain;
  }

  .alg-folder-search__result-icon--folder {
    color: var(--alg-folder-color, #d9e021);
  }

  /* `min-width: 0` : sans lui, la troncature des deux lignes ne s'applique jamais. */
  .alg-folder-search__result-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .alg-folder-search__result-name,
  .alg-folder-search__result-path {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .alg-folder-search__result-path {
    font-size: 11px;
    opacity: 0.7;
  }

  /*
    Couleur des dossiers, partagee avec l'arborescence : declaree ici pour que le champ de
    recherche et son panneau de resultats l'utilisent aussi.
  */
  .alg-folder-pane {
    --alg-folder-color: #d9e021;
  }

  /* Le sticky porte sur l'ensemble champ + resultats, pour que le panneau suive le champ. */
  .alg-folder-search-wrapper {
    position: sticky;
    top: 0;
    z-index: 3;
    width: 100%;
  }

  /* Champ de recherche dans le dossier courant. */
  .alg-folder-search {
    display: flex;
    align-items: center;
    gap: 6px;
    box-sizing: border-box;
    width: 100%;
    padding: 4px 6px 4px 10px;
    background-color: var(--theme-card-background-color, #fff);
    border: 1px solid var(--theme-border-color, rgba(0, 0, 0, 0.12));
    border-radius: 18px;
  }

  .alg-folder-search:focus-within {
    border-color: var(--theme-primary-color, #1976d2);
    box-shadow: 0 0 0 1px var(--theme-primary-color, #1976d2);
  }

  .alg-folder-search__icon,
  .alg-folder-search__clear .mat-icon {
    width: 18px;
    height: 18px;
    font-size: 18px;
    line-height: 18px;
    color: var(--adf-theme-foreground-text-color-064, rgba(0, 0, 0, 0.54));
  }

  /* `min-width: 0` : sans lui un champ en flex refuse de descendre sous la largeur de son contenu. */
  .alg-folder-search__input {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: none;
    background: none;
    font: inherit;
    color: inherit;
    padding: 4px 0;
  }

  .alg-folder-search__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: none;
    cursor: pointer;
  }

  .alg-folder-search__clear:hover {
    background-color: var(--theme-grey-background-hover, rgba(0, 0, 0, 0.06));
  }

  /* Respiration entre le champ de recherche et la racine de l'arborescence. */
  .alg-folder-tree {
    display: block;
    width: 100%;
    margin-top: 12px;
  }

  .button-toggle {
    width: 24px;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;
    border-bottom-color: rgba(0, 0, 0, 0.07);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-top-color: rgba(0, 0, 0, 0.07);
    border-top-style: solid;
    border-top-width: 1px;
    box-sizing :border-box;
  }

  .button-toggle-open {
    border-left-color: rgba(0, 0, 0, 0.07);
    border-left-style: solid;
    border-left-width: 1px;
  }

  .button-toggle:hover {
    background-color: #f5f5f5;
  }

  /*
    Volet gauche : arborescence et recherche dans le dossier courant.
    Le remplissage etait un `padding-right: 15px` en style inline, d'ou un champ de recherche et une
    arborescence colles au bord gauche et au haut du volet.
  */
  .alg-folder-pane {
    flex-direction: column;
    position: relative;
    overflow: auto;
    white-space: nowrap;
    box-sizing: border-box;
    padding: 10px 12px 0 10px;
  }

  .tree-node-display {
    display: flex;
    /* 20 % laissait 207 px a 1600 : le libelle du champ de recherche etait coupe. */
    width: 22%;
    min-width: 240px;
    max-width: 380px;
  }

  .tree-node-hide {
    display: none;
    width: 0;
  }

</style>
